import React, { useState, useEffect, useRef } from 'react';
import {
  Modal,
  ModalHeader,
  Table,
  Input,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCurrentAgencyId } from '../../../utils/functions/CustomFunctions';
import { debounce } from 'underscore';
import { getInvoiceList } from '../../../redux/actions';
import CustomTableLoader from '../../common/CustomTableLoader';

function InvoiceModalSearch(props) {
  const {
    toggle,
    modal = false,
    selectCallBack,
    showInvoiceInfo,
    data = '',
  } = props;
  const dispatch = useDispatch();

  // Reducer
  const InvoiceListReducer = useSelector((state) => state.InvoiceListReducer);
  const { loading = false, list = [], totalCount = 0 } = InvoiceListReducer;

  const [filter, setFilter] = useState({
    invoiceNumber: '',
    customerName: data,
  });

  //Onchange filter
  const changeSearchField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        dispatch(
          getInvoiceList({
            ...filter,
            agencyId: getCurrentAgencyId(),
          })
        ),

      500
    )
  ).current;

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  return (
    <>
      <Modal
        centered
        isOpen={modal}
        toggle={toggle}
        // style={{ top: '185px', left: '81px' }}
      >
        <ModalHeader toggle={toggle}>Select a Invoice</ModalHeader>
        <div style={{ margin: '10px' }}>
          <InputGroup size="sm">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i class="fa fa-search" aria-hidden="true"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              type="text"
              name="invoiceNumber"
              placeholder="Invoice Number"
              onChange={changeSearchField}
              value={filter.invoiceNumber}
              placeholder="select a invoice"
            />
          </InputGroup>
        </div>
        <div className="modals-scroll">
          <Table hover>
            {loading && (
              // Table Loader
              <CustomTableLoader columnsCount={1} />
            )}
            <tbody>
              <>
                {list.map((record, key) => {
                  const {
                    invoiceNumber = 0,
                    invoiceMasterId = 0,
                    paymentAmount = 0,
                  } = record;
                  return (
                    <tr key={key}>
                      <td
                        style={{ cursor: 'pointer' }}
                        data-details={JSON.stringify(record)}
                        data-id={invoiceMasterId}
                        onClick={selectCallBack}
                      >
                        {invoiceNumber} - {paymentAmount || 0}
                        {
                          <Link
                            to={`/view-invoice/${invoiceMasterId}`}
                            target="_blank"
                            onClick={showInvoiceInfo}
                            style={{ marginLeft: '1rem' }}
                          >
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                          </Link>
                        }
                      </td>
                    </tr>
                  );
                })}
              </>
            </tbody>
          </Table>
        </div>
      </Modal>
    </>
  );
}

export default InvoiceModalSearch;
